import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@/components/ui/input";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import Paginat from "@/components/lib/paginat";
import TimeSheetReportTable from "@/components/backoffice/all-staff/time-sheet/time-sheet-report-table";
import { Search } from "lucide-react";
import { useParams } from "react-router-dom";
import { fetchPresentDataByDate } from "@/redux/slice/staff-management/time-sheet-slice";
import useAuth from "@/hooks/useAuth";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StaffTableSkeleton from "@/components/skeleton/Staff-skeletion";
import { useSearch } from "@/hooks/useSearch";

function TimeSheetReport() {
  const { date } = useParams();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const { getPresentLoading, presentData } = useSelector(
    (state) => state.staffManage.timeSheet
  );

  const searchData = useSearch(
    presentData?.attendances || [],
    searchText,
    ["designation", "name"],
    300
  );

  useEffect(() => {
    if (!date) return navigate("/backoffice/staff-management/time-sheet");
    dispatch(
      fetchPresentDataByDate({
        restaurant_id: user?.restaurant_id,
        date: date,
        page: page,
        perPage: perPage,
      })
    );
  }, [date, user?.restaurant_id, page, perPage]);

  if (getPresentLoading) return <StaffTableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ icon: true, title: `${presentData?.date}` }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        {
          name: "Time Sheet",
          path: "/backoffice/staff-management/time-sheet",
        },
      ]}
    >
      <div className="container flex flex-col  mt-5">
        <div className="flex justify-end">
          <h1 className="text-cyellow">
            Total Staff: {presentData?.staff_count || "0"}
          </h1>
        </div>
        <div className="mt-5">
          <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
            <div className="w-[260px]">
              <div className="relative">
                <Search
                  size={18}
                  className="text-cwhite3 absolute top-2 left-2"
                />
                <Input
                  placeholder="Search by Name or ID"
                  onChange={(e) => setSearchText(e.target.value)}
                  className="bg-cblack3 pl-8"
                />
              </div>
            </div>
            <div className="flex flex-col  gap-1.5 justify-end items-end">
              <div className="flex gap-3 justify-center items-center">
                <div className="flex gap-1 justify-center items-center">
                  <h3 className="text-white">Show</h3>
                  <Select
                    onValueChange={(value) => setPerPage(Number(value))}
                    value={perPage.toString()}
                  >
                    <SelectTrigger className="w-[60px]">
                      <SelectValue placeholder="10" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectItem value="10">10</SelectItem>
                        <SelectItem value="20">20</SelectItem>
                        <SelectItem value="40">40</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <TimeSheetReportTable data={searchData || []} />
          </div>
          <div>
            <Paginat
              className="mt-2"
              pagination={presentData?.pagination || {}}
              onPageChange={(page) => setPage(page)}
            />
          </div>
        </div>
      </div>
    </Layout2>
  );
}

export default TimeSheetReport;

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});
